import viewService from "@/services/viewService";
import EntityService from "@/services/entityService";

const finPayService = new EntityService("FinPay");

const toNumber = (valor) => {
  const numero = Number(valor);
  return Number.isFinite(numero) ? numero : 0;
};

const isPossivelId = (valor) => {
  if (valor === null || valor === undefined) return false;
  const texto = String(valor).trim();
  return /^[0-9a-f]{24}$/i.test(texto) || /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(texto);
};

const primeiroValorValido = (candidatos = []) => {
  for (const valor of candidatos) {
    if (valor !== null && valor !== undefined && String(valor).trim() !== "") {
      return valor;
    }
  }
  return null;
};

const resolverNumeroParcela = (linha = {}) => {
  const direto = primeiroValorValido([
    linha.numParcelas,
    linha.numeroParcela,
    linha.parcelaNumero,
    linha.numeroDaParcela,
    linha.installmentNumber,
    linha.parcela,
    linha.pedidoDeCompraParcelaNumero,
    linha.pedidoDeCompraParcelaIndex,
    linha.parcelaSequencia,
    linha.parcelaOrdem
  ]);

  if (Array.isArray(linha.pedidoDeCompraParcela) && linha.pedidoDeCompraParcela.length > 0) {
    return String(linha.pedidoDeCompraParcela.length);
  }

  if (isPossivelId(direto)) {
    return "-";
  }

  return direto !== null ? String(direto) : "-";
};

const resolverStatusBaixa = (linha = {}) => {
  const statusDireto = primeiroValorValido([
    linha.status,
    linha.situacao,
    linha.statusPagamento,
    linha.pagamentoStatus
  ]);

  if (statusDireto !== null) return String(statusDireto);

  const baixadoFlag = linha.baixado === true || linha.isPaid === true || linha.pago === true;
  const possuiDataPagamento = Boolean(linha.dataPagamento || linha.paidAt);
  if (baixadoFlag || possuiDataPagamento) return "baixado";

  return "não baixado";
};

const normalizarLinha = (linha = {}) => {
  return {
    empresa: linha.filialNome || linha.empresa || "-",
    pedido: linha.pedidoDeCompraCodigo || linha.pedido || "-",
    ordemPagamento: linha.ordemDePagamentoCodigo || linha.ordemPagamento || "-",
    job: linha.job || linha.jobCode || "-",
    os: linha.os || linha.ordemServico || "-",
    centroCusto: linha.centroCusto || "-",
    grupoDesp: linha.grupoDesp || linha.origem || "-",
    numeroNotaFiscal: linha.numeroNotaFiscal || linha.numero || linha.notaNumero || "-",
    dataEmissao: linha.dataEmissao || linha.createAt || null,
    vencimento: linha.dataVencimento || linha.vencimento || null,
    numParcelas: resolverNumeroParcela(linha),
    valorParcela: toNumber(linha.valorPagamento || linha.valorParcela || 0),
    valorTotalNota: toNumber(linha.valorOriginal || linha.valorTotal || 0),
    remetente: linha.favorecidoFornecedorNome || linha.fornecedorNome || "-",
    cnpjEmitente: linha.favorecidoFornecedorCnpj || linha.emit_cnpj || "-",
    status: resolverStatusBaixa(linha),
    cfop: linha.cfop || "-",
    naturezaOperacao: linha.naturezaOperacao || linha.pagamentoTipo || linha.origem || "-",
    infoComplementares: linha.descricao || "-"
  };
};

const extrairLista = (response) => {
  const lista = response?.data?.data?.data;
  if (Array.isArray(lista)) return lista;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

const possuiDadosValidos = (response) => {
  if (!response) return false;
  if (response?.success === false) return false;
  if (response?.data?.success === false) return false;
  return Array.isArray(response?.data?.data?.data) || Array.isArray(response?.data);
};

const listarPorEntidade = async () => {
  const response = await finPayService.getAll(1, 5000, "", "", null, null, null, "dataVencimento");
  return extrairLista(response);
};

const listarPorView = async (params = []) => {
  const viewNames = [
    "relatorio-contas-pagar",
    "df2990fb-e9d5-4303-8400-605f89af52ea",
    "finpay"
  ];

  for (const viewName of viewNames) {
    const response = await viewService.viewRun(viewName, 1, params);
    if (possuiDadosValidos(response)) {
      return extrairLista(response);
    }
  }

  return [];
};

export default {
  async listarContasAPagar(filtros = {}) {
    const params = [];

    if (filtros.dataInicio) {
      params.push({ dataType: "String", name: "dataInicio", value: filtros.dataInicio });
    }

    if (filtros.dataFim) {
      params.push({ dataType: "String", name: "dataFim", value: filtros.dataFim });
    }

    if (filtros.fornecedor) {
      params.push({ dataType: "String", name: "fornecedor", value: filtros.fornecedor });
    }

    if (filtros.empresa) {
      params.push({ dataType: "String", name: "empresa", value: filtros.empresa });
    }

    let lista = await listarPorView(params);

    if (!lista.length) {
      lista = await listarPorEntidade();
    }

    return lista.map((linha) => normalizarLinha(linha));
  }
};
